const commissionItemsSortOptions = [
    {id: 'date_desc', text: 'Date: Newest'},
    {id: 'date_asc', text: 'Date: Oldest'},
    {id: 'payment', text: 'Payment'},
]

const commissionPaymentOptions = [
    {id: 'all', text: 'All Payment'},
    {id: '', text: 'Sales'},
    {id: 'credits', text: 'Redeem by Credits'},
    {id: 'package', text: 'Redeem by Package'},
]

const dashboardSalesSummaryBox = [
    {id: "thisYearSales", background: "bg-primary-300", icon: "fa-chart-line", value: "-"},
    {id: "lastYearSales", background: "bg-warning-400", icon: "fa-chart-line", value: "-"},
    {id: "tyMonthlyAvg", background: "bg-success-500", icon: "fa-chart-bar", value: "-"},
    // {id: "tyMonthlySales", background: "bg-danger-300", icon: "fa-chart-area", value: "-"},
]

const stockBalanceReportSummaryBox = [
    {id: "price_inventory", background: "bg-primary-300", icon: "fa-dollar-sign", value: "-"},
    {id: "cost_inventory", background: "bg-warning-400", icon: "fa-money-check-alt", value: "-"},
]

const salesReportSummaryBox = [
    {id: "sales", background: "bg-primary-300", icon: "fa-dollar-sign", value: "-"},
    {id: "credit_redeem", background: "bg-warning-400", icon: "fa-money-check-alt", value: "-"},
    {id: "package_redeem", background: "bg-success-500", icon: "fa-box-alt", value: "-"},
    {id: "total", background: "bg-info-200", icon: "fa-chart-line", value: "-"},
]

const creditReportSummaryBox = [
    {id: "top_up", background: "bg-primary-300", icon: "fa-arrow-square-up", value: "-"},
    {id: "redeem", background: "bg-warning-400", icon: "fa-minus-square", value: "-"},
]

const outStandingsReportSummaryBox = [
    {id: "outstandings", background: "bg-primary-300", icon: "fa-cart-arrow-down", value: "-"},
    {id: "collection", background: "bg-warning-400", icon: "fa-cart-plus", value: "-"},
]

const voucherReportSummaryBox = [
    {id: "sign_up", background: "bg-primary-300", icon: "fa-arrow-square-up", value: "-"},
    {id: "redeem", background: "bg-warning-400", icon: "fa-minus-square", value: "-"},
    {id: "expired", background: "bg-danger-300", icon: "fa-calendar-exclamation", value: "-"},
    {id: "balance", background: "bg-success-300", icon: "fa-search-dollar", value: "-"},
]

const voucherReportSummaryCustomerBox = [
    {id: "total", background: "bg-primary-300", icon: "fa-ticket-alt", value: "-"},
    {id: "amount", background: "bg-warning-400", icon: "fa-dollar-sign", value: "-"},
]

const salesReportOrderTypes = [
    {id: "all", text: "All Orders"},
    {id: "shop", text: "Shop"},
    {id: "online", text: "Online"},
    {id: "voided", text: "Voided"},
]

const salesReportItemTypes = [
    {id: "all", text: "All Item Types"},
    {id: "service", text: "Service"},
    {id: "product", text: "Product"},
    {id: "package", text: "Package"},
    {id: "discount", text: "Discount"},
    {id: "outstandings", text: "Outstandings"},
]

const commissionReportItemType = [
    {id: 'service', icon: 'fa-user-cog', title: ""},
    {id: 'product', icon: 'fa-box-open', title: ""},
    {id: 'package', icon: 'fa-box-alt', title: ""},
    {id: 'outstandings', icon: 'fa-cart-plus', title: ""}
]

const paymentTypeOptions = [
    { text: 'Current', value: 'current' },
    { text: 'All', value: 'all' },
    { text: 'Customize', value: 'customize' },
]

const attendanceDateFilteOptions = [
    { text: 'All', value: 'all' },
    { text: 'By Entry Date', value: 'entry' },
    { text: 'By Exit Date', value: 'exit' },
]

const voucherDateFilteOptions = [
    { text: 'All', value: 'all' },
    { text: 'Expiry Date', value: 'expiry' },
]

function calculateTotalRedeem(redeem, price, staffs, item){
    if(redeem == ""){
        item.sales += price;
        item.sales = parseFloat(item.sales.toFixed(2)); 
        item.salesQty ++;

        if(staffs.length != 0){
            for(var j=0; j<staffs.length; j++){
                item.salesEffort += staffs[j].effort;
                item.salesFee += staffs[j].fee;
            }
        }

    }else if(redeem == "credits"){
        item.credits += price;
        item.credits = parseFloat(item.credits.toFixed(2)); 
        item.creditQty ++;

        if(staffs.length != 0){
            for(var k=0; k<staffs.length; k++){
                item.creditEffort += staffs[k].effort;
                item.creditFee += staffs[k].fee;
            }
        }
    }else{
        item.packages += price;
        item.packages = parseFloat(item.packages.toFixed(2)); 
        item.packageQty ++;

        if(staffs.length != 0){
            for(var l=0; l<staffs.length; l++){
                item.packageEffort += staffs[l].effort;
                item.packageFee += staffs[l].fee;
            }
        }
    }
    return item;
}

function calculateTotalStaffEffortFee(staff){
    var effort = 0;
    var fee = 0
    for(var i=0; i<staff.length; i++){
        effort += staff[i].effort
        fee += staff[i].fee
    }
    return {effort: effort, fee: fee}
}

function calculateCategoryTotalRedeem(id, redeem, price, discount, outstandings, staffs, item){
    if(redeem == ""){
        item.sales += getSubTotal(price, discount, outstandings);
        item.salesQty ++;

        if(staffs.length != 0){
            for(var j=0; j<staffs.length; j++){
                if(id == ""){
                    item.salesEffort += staffs[j].effort;
                    item.salesFee += staffs[j].fee;
                }else{
                    if(staffs[j].staffID == parseInt(id)){
                        item.salesEffort += staffs[j].effort;
                        item.salesFee += staffs[j].fee;
                    }
                }
            }
        }
    }else if(redeem == "credits"){
        item.credits += getSubTotal(price, discount, outstandings);
        item.creditsQty ++;

        if(staffs.length != 0){
            for(var k=0; k<staffs.length; k++){
                if(id == ""){
                    item.creditEffort += staffs[k].effort;
                    item.creditFee += staffs[k].fee;
                }else{
                    if(staffs[k].staffID == parseInt(id)){
                        item.creditEffort += staffs[k].effort;
                        item.creditFee += staffs[k].fee;
                    }
                }
            }
        }
    }else{
        item.packages += getSubTotal(price, discount, outstandings);
        item.packagesQty ++;

        if(staffs.length != 0){
            for(var l=0; l<staffs.length; l++){
                if(id == ""){
                    item.packageEffort += staffs[l].effort;
                    item.packageFee += staffs[l].fee;
                }else{
                    if(staffs[l].staffID == parseInt(id)){
                        item.packageEffort += staffs[l].effort;
                        item.packageFee += staffs[l].fee;
                    }
                }
            }
        }
    }

    for(var m=0; m<staffs.length; m++){
        if(staffs[m].staffID == parseInt(id)){
            item.fee += staffs[m].fee;
        }
    }
    return item;
}

function calculateSalesReportTotal(item){
    var totalPrice = 0; var totalDiscount = 0; var totalOutstandings = 0; var totalTax= 0;
    var totalSales = 0; var totalCredits = 0; var totalPackage = 0;
    var subTotal = 0;

    for(var i=0; i<item.length; i++){
        var price = item[i].price;
        var discount = item[i].discount;
        var outstandings = item[i].outstandings;
        var taxType = item[i].tax.taxType;
        var tax = item[i].tax.tax;

        if(item[i].redeem == "credits"){
            totalCredits = totalCredits += getSubTotal(price, discount, outstandings, taxType, tax)
        }else if(item[i].redeem == "package"){
            totalPackage = totalPackage += getSubTotal(price, discount, outstandings, taxType, tax)
        }else{
            totalSales = totalSales += getSubTotal(price, discount, outstandings, taxType, tax)
        }
        totalPrice = parseFloat((totalPrice += price).toFixed(2));
        totalDiscount = parseFloat((totalDiscount += discount).toFixed(2));
        totalOutstandings = parseFloat((totalOutstandings += outstandings).toFixed(2)); 
        totalTax = parseFloat((totalTax += tax).toFixed(2)); 
        var _subTotal = getSubTotal(price, discount, outstandings, taxType, tax)
        subTotal += _subTotal
    }
    return {
        totalSales: totalSales,
        totalCredits: totalCredits,
        totalPackage: totalPackage,
        totalPrice: totalPrice,
        totalDiscount: totalDiscount,
        totalOutstandings: totalOutstandings,
        totalTax: totalTax,
        subTotal: subTotal
    }
}

function getSubTotal(price, discount, outstandings, taxType, tax){
    var subtraction = parseFloat(price.toFixed(2)) - parseFloat(discount.toFixed(2)) - parseFloat(outstandings.toFixed(2));
    if(taxType && tax) {
        if(taxType === 'inclusiveTax') {
            subtraction -= tax
        }
    }
    return subtraction
}

function setStaffCommissionItems(items, staffID){
    for(var key in items){
        var item = items[key]
        var totalService = 0; var totalProduct = 0; var totalPackage = 0; var totalDiscount = 0; var totalOutstandings = 0

        for(var k=0; k<item.length; k++){
            if(item[k].staffs.length != 0){
                var staff = item[k].staffs.filter(o=> o.staffID == staffID)
                switch(item[k].item.type){
                    case"service":
                        totalService += staff[0].effort
                        break;
                    case"product":
                        totalProduct += staff[0].effort
                        break;
                    case"package":
                        totalPackage += staff[0].effort
                        break;
                    case"outstandings":
                        totalOutstandings += staff[0].effort
                        break;

                }
            }
        }
        var total = parseFloat(totalService.toFixed(2)) + 
                    parseFloat(totalProduct.toFixed(2)) +
                    parseFloat(totalPackage.toFixed(2)) +
                    parseFloat(totalDiscount.toFixed(2)) +
                    parseFloat(totalOutstandings.toFixed(2))

        items[key] = {
            service: totalService,
            product: totalProduct,
            package: totalPackage,
            outstandings: totalOutstandings,
            total: total
        }
    }
    return items
}

function setSalesCommissionItems(reordered){
    for(var key in reordered){
        var item = reordered[key]
        var totalService = 0; var totalProduct = 0; var totalPackage = 0; var totalDiscount = 0; var totalOutstandings = 0

        for(var k=0; k<item.length; k++){
            var price = item[k].price
            var discount = item[k].discount
            var outstandings = item[k].outstandings
            var tax = item[k].tax.tax
            var taxType = item[k].tax.taxType;

            switch(item[k].item.type){
                case"service":
                    totalService += getSubTotal(price, discount, outstandings, taxType, tax)
                    break;
                case"product":
                    totalProduct += getSubTotal(price, discount, outstandings, taxType, tax)
                    break;
                case"package":
                    totalPackage += getSubTotal(price, discount, outstandings, taxType, tax)
                    break;
                case"discount":
                    totalDiscount += getSubTotal(price, discount, outstandings, taxType, tax)
                    break;
                case"outstandings":
                    totalOutstandings += getSubTotal(price, discount, outstandings, taxType, tax)
                    break;

            }
        }
        var total = parseFloat(totalService.toFixed(2)) + 
                    parseFloat(totalProduct.toFixed(2)) +
                    parseFloat(totalPackage.toFixed(2)) +
                    parseFloat(totalDiscount.toFixed(2)) +
                    parseFloat(totalOutstandings.toFixed(2))

        reordered[key] = {
            service: totalService,
            product: totalProduct,
            package: totalPackage,
            discount: totalDiscount,
            outstandings: totalOutstandings,
            total: total
        }
    }
    return reordered
}

function calculateSalesReportDateTotal(items){
    var totalService = 0; var totalProduct = 0; var totalPackage = 0; var totalDiscount = 0; var totalOutstandings = 0; var total = 0
    for(var key in items){
        var item = items[key]
        for(var itemType in item){
            switch(itemType){
                case"service":
                totalService += parseFloat(item[itemType].toFixed(2))
                break;
                case"product":
                totalProduct += parseFloat(item[itemType].toFixed(2))
                break;
                case"package":
                totalPackage += parseFloat(item[itemType].toFixed(2))
                break;
                case"discount":
                totalDiscount += parseFloat(item[itemType].toFixed(2))
                break;
                case"outstandings":
                totalOutstandings += parseFloat(item[itemType].toFixed(2))
                break;
                case"total":
                total += parseFloat(item[itemType].toFixed(2))
                break;
            }
        }
    }
    var data = {
        service: parseFloat(totalService.toFixed(2)),
        product: parseFloat(totalProduct.toFixed(2)),
        package: parseFloat(totalPackage.toFixed(2)),
        discount: parseFloat(totalDiscount.toFixed(2)),
        outstandings: parseFloat(totalOutstandings.toFixed(2)),
        total: parseFloat(total.toFixed(2))
    }
    return data      
}

function calculateEffortPercentage(amount, effort){
    amount = typeof amount == 'string' ?  parseFloat(amount.replace(",", "")) : amount
    var percentage = (effort/amount)*100;
    return percentage
}

function setCreditSummaryItems(items){
    for(var key in items){
        var item = items[key]
        if(item.length == 0){
            items[key] = {
                topup: 0,
                redeem: 0, 
                balance: 0
            }
        }else{
            var topup = 0; var redeem = 0; var balance = 0;
            for(var i=0; i<item.length; i++){
                if(Math.sign(item[i].amount) == 1){
                    topup += item[i].amount
                }else{
                    redeem += item[i].amount
                }
            }
            balance = topup + redeem;
            items[key] = {
                topup: topup,
                redeem: redeem, 
                balance: balance
            }
        }   
    }
    return items;
}

function setPointsSummaryItems(items){
    for(var key in items){
        var item = items[key]
        if(item.length == 0){
            items[key] = {
                topup: 0,
                redeem: 0, 
                balance: 0
            }
        }else{
            var topup = 0; var redeem = 0; var balance = 0;
            for(var i=0; i<item.length; i++){
                if(Math.sign(item[i].point) == 1){
                    topup += item[i].point
                }else{
                    redeem += item[i].point
                }
            }
            balance = topup + redeem;
            items[key] = {
                topup: topup,
                redeem: redeem, 
                balance: balance
            }
        }   
    }
    return items;
}

function setVoucherSummaryItems(item, startDate, endDate){
    var result ={}
    if(item.length == 0){
        result = {
            signup: 0,
            redeem: 0, 
            expired: 0,
            balance: 0,
            totalSignup: 0,
            totalRedeem: 0,
            totalExpired: 0,
            totalBalance: 0,
        }
    }else{
        var signup = 0; var redeem = 0; var expired = 0; var balance = 0;
        var totalSignup = 0; var totalRedeem = 0; var totalExpired = 0; var totalBalance = 0

        for(var i=0; i<item.length; i++){
            if(item[i].expiredDate != 0){
                if(item[i].expiredDate >= startDate && item[i].expiredDate <= endDate){
                    expired++;
                    totalExpired += item[i].unitPrice
                } 
            }
            if(item[i].redeemDate != 0){
                if(item[i].redeemDate >= startDate && item[i].redeemDate <= endDate){
                    redeem++;
                    totalRedeem += item[i].unitPrice
                }
            }
            if(item[i].purchaseDate != 0){
                if(item[i].purchaseDate >= startDate && item[i].purchaseDate <= endDate){
                    signup++;
                    totalSignup += item[i].unitPrice
                }
            }
        }
        result = {
            signup: signup,
            redeem: redeem, 
            expired: expired,
            balance: signup - redeem - expired,
            totalSignup: totalSignup, 
            totalRedeem: totalRedeem,
            totalExpired: totalExpired,
            totalBalance: totalSignup - totalRedeem - totalExpired
        }
    } 
    return result 
}

function getPaymentTypeTitle(id, items){
    var title = ""
    for(var i=0; i<items.length; i++){
        if(id == items[i].paymentTypeID){
            title = items[i].title
            break
        }
    }
    return title
}

function calculateTotalByPaymentType(items){
    var total = 0
    for(var i=0; i<items.length; i++){
        total += items[i].amount
    }
    return total
}

function setPaymentItemsByPaymentType(items, paymentMethods){
    for(var k in items){
        var keys = Object.keys(items[k])
        if(keys.length != 0){
            for(var i=0; i<paymentMethods.length; i++){
                var strPaymentID = (paymentMethods[i].paymentTypeID).toString()
                if(keys.indexOf(strPaymentID) == -1){
                    var obj = {}
                    obj[paymentMethods[i].paymentTypeID] = []
                    Object.assign(items[k], obj)
                }
            }
            for(var r in items[k]){
                const isExists = paymentMethods.some(o=> o.paymentTypeID == parseInt(r))
                if(!isExists){
                    delete items[k][r]
                }
            }
            
        }
    }
    return items
}

function setPaymentTotal(group, paymentType){
    var arrTotal = []
    for(var k in group){
        arrTotal.push({
            paymentTypeID: parseInt(k),
            paymentMethod: getPaymentTypeTitle(parseInt(k), paymentType),
            total: calculateTotalByPaymentType(group[k]),
        })
    }
    return arrTotal
}

function setExportDataByPaymentMethod(obj, paymentItems, paymentMethods){
    for(var i=0; i<paymentMethods.length; i++){
        var found = paymentItems.filter(o=> paymentMethods[i].paymentTypeID == o.paymentTypeID)
        obj[paymentMethods[i].paymentTypeID] = found.length != 0 ? found[0].amount : 0
    }
    return obj
}

export{
    calculateTotalStaffEffortFee, 
    calculateTotalRedeem, calculateCategoryTotalRedeem,
    calculateSalesReportTotal, getSubTotal,
    setSalesCommissionItems, calculateSalesReportDateTotal,
    calculateEffortPercentage,
    setCreditSummaryItems, 
    setPointsSummaryItems,
    setVoucherSummaryItems,
    calculateTotalByPaymentType, 
    getPaymentTypeTitle, setPaymentItemsByPaymentType, setExportDataByPaymentMethod, setPaymentTotal,
    setStaffCommissionItems
}

export default{
    stockBalanceReportSummaryBox: stockBalanceReportSummaryBox,
    salesReportSummaryBox: salesReportSummaryBox,
    salesReportOrderTypes: salesReportOrderTypes,
    salesReportItemTypes: salesReportItemTypes,
    creditReportSummaryBox: creditReportSummaryBox,
    commissionReportItemType: commissionReportItemType,
    outStandingsReportSummaryBox: outStandingsReportSummaryBox,
    voucherReportSummaryBox: voucherReportSummaryBox,
    attendanceDateFilteOptions: attendanceDateFilteOptions,
    voucherDateFilteOptions: voucherDateFilteOptions,
    voucherReportSummaryCustomerBox: voucherReportSummaryCustomerBox,
    dashboardSalesSummaryBox: dashboardSalesSummaryBox,
    paymentTypeOptions: paymentTypeOptions, 
    commissionPaymentOptions: commissionPaymentOptions,
    commissionItemsSortOptions: commissionItemsSortOptions
   
}
